import { render, staticRenderFns } from "./DocumentPOSCardChange.vue?vue&type=template&id=62eb9f6c"
import script from "./DocumentPOSCardChange.vue?vue&type=script&lang=js"
export * from "./DocumentPOSCardChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports